











import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import VHeaderItem from '@/components/report/item/VHeaderItem.vue';
import VHeaderIndividualItem from '@/components/report/item/VHeaderIndividualItem.vue';
import reportViewModel from '@/views/mastercoach/reportViewModel';

@Component({
  name: 'ReportDetail',
  components: { VHeaderIndividualItem, VHeaderItem }
})
export default class ReportDetail extends Vue {
  destroyed() {
    reportViewModel.clean();
  }
}
